export { default } from './fareCards'
